import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.42103 6.86127L16.1385 13.5788L5.83928 20.2501L2.81641 17.2272L9.42103 6.86127Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.3866 9.75516C18.8563 10.2855 18.5068 10.2896 17.9805 10.4705C17.9642 11.8684 17.9836 13.2751 16.2097 13.6225L9.30176 6.71451C9.30176 6.71451 9.29711 6.02971 9.99981 5.67171C10.2473 5.55576 10.749 5.61061 11.048 5.65926C11.7512 4.14682 12.8158 3.89151 13.9995 4.38049C14.5673 3.52165 15.9693 3.1559 17.0136 3.49315C18.058 3.83039 18.0498 4.52931 18.7447 4.87064C19.4396 5.21196 20.1467 4.50485 20.1507 4.15538C20.1548 3.8059 20.0935 3.13739 20.5646 3.25861C20.8522 3.33623 21.0836 3.61611 21.3624 4.78063C21.5181 5.43431 21.4276 6.40131 20.869 6.99496C20.5262 7.35926 19.7607 7.54971 19.4111 7.65831C19.4444 7.75356 19.9169 9.22486 19.3866 9.75516Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.4105 7.65817C18.0044 8.37342 16.96 8.03617 15.9238 6.99997",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }